import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import i18n from 'simple-react-i18n'
import useTitle from '../../../../utils/customHook/useTitle'
import { PATH_RPQS_REFERENCIAL_MANAGEMENT_ENTITY } from '../../../../home/constants/RouteConstants'
import RpqsReferentialEventsApp from '../../events/RpqsReferentialEventsApp'

const ManagementEntityReferentialEventApp = () => {
    const { code } = useParams()

    const {
        managementUnit,
    } = useSelector(store => ({
        managementUnit: store.RpqsReducer.managementUnit,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.rpqs,
        href: 'rpqs',
    }, {
        title: i18n.RPQSReferencials,
        href: 'rpqs/referencials',
    }, {
        title: i18n.managementEntities,
        href: PATH_RPQS_REFERENCIAL_MANAGEMENT_ENTITY,
    }, {
        title: managementUnit?.name,
        href: `${PATH_RPQS_REFERENCIAL_MANAGEMENT_ENTITY}${code}/dashboard`,
    }, {
        title: i18n.event,
        href: `${PATH_RPQS_REFERENCIAL_MANAGEMENT_ENTITY}${code}/event`,
    }], [managementUnit, code])

    return <RpqsReferentialEventsApp managementUnitId={code} />
}

export default ManagementEntityReferentialEventApp
